export default (element) => element.offsetHeight
